import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendListModel } from '../models/common/list.model';
import { FeedbackMaster } from '../models/feedback-master';
import { FeedbackMultiple } from '../models/feedback-multiple';
import { ApiRoutes } from './apiroutes';
import { Feedback } from '../models/feedback';

@Injectable({
  providedIn: 'root'
})
export class FeedbackMasterApiService {
  base_url = ApiRoutes.Booking;

  constructor(private http: HttpClient) { }

  getFeedback(reqID): Observable<BackendListModel<FeedbackMaster>> {
    let url = `${this.base_url}feedback_master/?request_id=${reqID}`;
    return this.http.get<BackendListModel<FeedbackMaster>>(url);
  }

  // postFeedback(feedback,id) {
  //   let url = `${this.base_url}feedback_multiple/${id}/`;
  //   return this.http.put(url,feedback);
  // }
  postFeedback(feedback) {
    let url = `${this.base_url}feedback_multiple/`;
    return this.http.post(url,feedback);
  }
  updateFeedback(feedback,fID) {
    let url = `${this.base_url}feedback/${fID}/`;
    return this.http.post(url,feedback);
  }
  getFeedbackbyReqID(reqID): Observable<BackendListModel<Feedback>> {
    let url = `${this.base_url}feedback/?request_id=${reqID}`;
    return this.http.get<BackendListModel<Feedback>>(url);
  }
}
